// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__E7CD2","lastLink":"HeadPage_lastLink__18w-9"};